<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6592 9.17098H6.35083L10.4175 5.10432C10.7425 4.77932 10.7425 4.24598 10.4175 3.92098C10.2618 3.76494 10.0504 3.67725 9.83 3.67725C9.60957 3.67725 9.39819 3.76494 9.2425 3.92098L3.75083 9.41265C3.42583 9.73765 3.42583 10.2627 3.75083 10.5876L9.2425 16.0793C9.5675 16.4043 10.0925 16.4043 10.4175 16.0793C10.7425 15.7543 10.7425 15.2293 10.4175 14.9043L6.35083 10.8376H15.6592C16.1175 10.8376 16.4925 10.4626 16.4925 10.0043C16.4925 9.54598 16.1175 9.17098 15.6592 9.17098Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
